"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteHeader = exports.InvitePageWrapper = exports.SplitWrapper = exports.Logo = exports.Login = exports.ValuePropWrapper = exports.FormWrapper = exports.LoadingPageBlank = exports.LoadingPage = exports.BasicWrapperBack = exports.BlankWrapper = exports.BasicWrapper = exports.FooterText = exports.VALUE_HEADING = void 0;
const React = __importStar(require("react"));
require("./layout.scss");
const snap_ui_1 = require("@teamsnap/snap-ui");
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
exports.VALUE_HEADING = 'Everything your team needs, all in one place';
const FooterText = () => {
    return (React.createElement(React.Fragment, null,
        "TeamSnap, 2045 W Grand Ave., Ste B PMB 23554, ",
        React.createElement("br", null),
        "Chicago, IL 60612-1577, USA"));
};
exports.FooterText = FooterText;
const BasicWrapper = (props) => {
    const { children } = props;
    return (React.createElement("div", { className: "sui-flex sui-flex-col signup-form-bg sui-w-full sui-min-h-screen sui-justify-between d:sui-justify-between sui-py-4 d:sui-items-center" },
        React.createElement("div", null),
        React.createElement("div", { className: "split-inner sui-px-2" },
            " ",
            children),
        React.createElement("div", { className: "copyright-footer sui-caption sui-text-center sui-mb-5 sui-mt-2 sui-text-neutral-text" },
            React.createElement(exports.FooterText, null))));
};
exports.BasicWrapper = BasicWrapper;
const BlankWrapper = (props) => {
    const { children } = props;
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-bg-white sui-w-full sui-min-h-screen sui-justify-between d:sui-justify-between sui-py-4 d:sui-items-center" },
        React.createElement("div", null),
        React.createElement("div", { className: "split-inner sui-px-2" },
            " ",
            children),
        React.createElement("div", null)));
};
exports.BlankWrapper = BlankWrapper;
const BasicWrapperBack = (props) => {
    const { children, onBack } = props;
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-w-full sui-min-h-screen d:sui-justify-between sui-py-4 d:sui-items-center sui-relative" },
        React.createElement("div", { className: "back-container sui-relative" }, onBack && (React.createElement(snap_ui_1.LabelButton, { "data-testid": "back", className: "d:sui-absolute back-button", icon: "chevron_left", iconPosition: "left", variantType: "tertiary", onClick: onBack, labelText: "Back" }))),
        React.createElement("div", { className: "split-inner sui-px-2" }, children),
        React.createElement("div", null)));
};
exports.BasicWrapperBack = BasicWrapperBack;
const LoadingPage = () => {
    return (React.createElement(exports.BasicWrapper, null,
        React.createElement("div", { className: "sui-text-center loading-page-content" },
            React.createElement(teamsnap_ui_1.Loader, { type: "pulse", size: { height: 16, width: 16 } }))));
};
exports.LoadingPage = LoadingPage;
const LoadingPageBlank = () => {
    return (React.createElement(exports.BlankWrapper, null,
        React.createElement("div", { className: "sui-text-center loading-page-content" },
            React.createElement(teamsnap_ui_1.Loader, { type: "pulse", size: { height: 16, width: 16 } }))));
};
exports.LoadingPageBlank = LoadingPageBlank;
const FormWrapper = (props) => {
    const { children } = props;
    return React.createElement("div", { className: "form-wrapper sui-bg-white sui-p-2" }, children);
};
exports.FormWrapper = FormWrapper;
const ValuePropWrapper = () => {
    return (React.createElement("div", { className: "value-prop sui-flex d:sui-h-screen sui-flex-col sui-justify-between" },
        React.createElement("div", null),
        React.createElement("div", null,
            React.createElement("div", { className: "sui-mb-4" },
                React.createElement("img", { src: "/images/ts-logo.png", className: "ts-logo" })),
            React.createElement("div", { className: "sui-font-size-12 sui-font-bold sui-mb-4" }, exports.VALUE_HEADING),
            React.createElement("div", { className: "sui-body" },
                React.createElement("p", null, "Rosters, schedules, availability, assignments, messaging, and even training content \u2014 TeamSnap brings everything together so your team can throw away the extra group texts, email chains, and apps."),
                React.createElement("p", null, "It\u2019s simple to use and designed to eliminate last-minute confusion \u2014 for teams of every size, age group, and competitive level."))),
        React.createElement("div", { className: "copyright-footer sui-caption sui-mb-5 sui-text-neutral-text-medium" },
            React.createElement(exports.FooterText, null))));
};
exports.ValuePropWrapper = ValuePropWrapper;
const Login = ({ onClick }) => {
    return (React.createElement("span", { className: "sui-inline-flex sui-items-center" },
        React.createElement("span", { className: "sui-caption sui-mr-0.5 sui-whitespace-nowrap" }, "Have an account? "),
        React.createElement(snap_ui_1.TextLink, { className: "sui-font-bold sui-caption", href: "", onClick: onClick }, "Log in")));
};
exports.Login = Login;
const Logo = ({ className }) => {
    return (React.createElement("div", { className: className },
        React.createElement("img", { src: "/images/ts-logo.png", className: "ts-logo" })));
};
exports.Logo = Logo;
const SplitWrapper = (props) => {
    const { children } = props;
    return (React.createElement("div", { className: "signup-wrapper-spilt sui-w-full sui-min-h-screen sui-flex sui-justify-stretch" },
        React.createElement("div", { className: "sui-hidden d:sui-flex sui-bg-white d:sui-w-1/2 sui-justify-center sui-items-center" },
            React.createElement("div", { className: "split-inner sui-px-2" },
                React.createElement(exports.ValuePropWrapper, null))),
        React.createElement("div", { className: "sui-flex sui-flex-col signup-form-bg sui-w-full d:sui-w-1/2 sui-justify-between d:sui-justify-center sui-py-4 d:sui-items-center" },
            React.createElement("div", { className: "split-inner sui-px-2" },
                " ",
                children),
            React.createElement("div", { className: "copyright-footer sui-caption sui-text-center sui-mb-5 sui-mt-2 d:sui-hidden sui-text-neutral-text" },
                React.createElement(exports.FooterText, null)))));
};
exports.SplitWrapper = SplitWrapper;
const InvitePageWrapper = (props) => {
    const { children } = props;
    return React.createElement("div", { className: "sui-p-2 invite-wrapper sui-flex sui-flex-col sui-items-center sui-font-sans" }, children);
};
exports.InvitePageWrapper = InvitePageWrapper;
const InviteHeader = ({ headerText, className }) => {
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "sui-flex sui-justify-center sui-mb-3" },
            React.createElement("img", { src: "/images/ts-logo.png", className: "ts-logo" })),
        React.createElement("p", { className: "sui-heading-sm sui-text-gray-40 sui-text-center" }, headerText)));
};
exports.InviteHeader = InviteHeader;
